import React from "react";
import _ from "lodash";
import ModalWrapper from "../common/ModalWrapper";
import PasswordEyeInput from "../common/PasswordEyeInput";

const inputClassDisabled =
  "bg-gray-300 flex w-full border border-gray-400 rounded py-1 px-3 appearance-none leading-normal";

class VaultUserNewPasswordModal extends React.Component {
  constructor(props) {
    super(props);

    const { user } = props;

    this.state = {
      user,
      newPassword: "",
    };

    this.handleCancel = this.handleCancel.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleNewPWChanged = this.handleNewPWChanged.bind(this);
  }

  handleCancel() {
    this.setState({
      user: null,
      newPassword: "",
    });
    this.props.handleClose();
  }

  handleSubmit() {
    const { newPassword } = this.state;
    this.props.handleSave({ newPassword });
  }

  handleNewPWChanged(e) {
    this.setState({ newPassword: e.target.value });
  }

  render() {
    const {
      user,
      isOpenModal,
      // handleClose,
      isSaving,
      saveErrorMsg,
    } = this.props;
    const { newPassword } = this.state;

    return (
      <ModalWrapper
        isOpen={isOpenModal}
        showCloseFooter={false}
        // handleClose={handleClose}
        width="50%"
        title={
          <div className="border-b -mx-6 mb-4 px-6 pb-2 text-lg font-bold">
            Set new password:
          </div>
        }
      >
        <div>
          <form
            autoComplete="false"
            onSubmit={(e) => {
              e.preventDefault();
              return this.handleSubmit();
            }}
          >
            <div>
              <div className="my-2">
                <label
                  className="mb-1 block pr-4 font-semibold leading-none text-gray-800"
                  htmlFor="user-email"
                >
                  Email{" "}
                  <span className="text-sm font-normal text-gray-700">
                    (Use the email that is used to sign in to Observer)
                  </span>
                </label>
                <div className="w-2/3">
                  <input
                    className={inputClassDisabled}
                    id="user-email"
                    type="email"
                    defaultValue={user.username}
                    disabled={true}
                  ></input>
                </div>
              </div>

              <div className="my-2">
                <label
                  className="mb-1 block pr-4 font-semibold leading-none text-gray-800"
                  htmlFor="i2w-vault-user-new-password"
                >
                  New Password
                </label>
                <div className="w-2/3">
                  <PasswordEyeInput
                    id="i2w-vault-user-new-password"
                    value={newPassword}
                    onChange={this.handleNewPWChanged}
                    required={true}
                  ></PasswordEyeInput>
                </div>
              </div>
            </div>

            <div className="mt-8 flex items-center justify-end">
              <div className="text-red-700">{saveErrorMsg}</div>
              <button
                className="rounded flex-shrink-0 border-4 border-transparent px-2 py-1 text-sm text-blue-500 hover:text-blue-800"
                type="button"
                onClick={this.handleCancel}
              >
                Cancel
              </button>

              <button
                className="rounded flex-shrink-0 border-4 border-blue-500 bg-blue-500 px-2 py-1 text-sm font-semibold text-white hover:border-blue-700 hover:bg-blue-800"
                type="submit"
                disabled={isSaving}
              >
                {isSaving ? "Saving..." : "Change password"}
              </button>
            </div>
          </form>
        </div>
      </ModalWrapper>
    );
  }
}

export default VaultUserNewPasswordModal;
